import React, { useState, useEffect } from 'react';
import { Zap, Award, Star, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const walkInTattoos = [
  { id: 1, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132863/Walk_in_tattoo_newquay.jpg', alt: 'Walk-in tattoo Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 2, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132863/Fine_line_tattoo_newquay.jpg', alt: 'Fine line tattoo Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 3, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132862/Tattoo_flash_designs_newquay.jpg', alt: 'Tattoo flash designs Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 4, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132862/Small_tattoos_newquay.jpg', alt: 'Small tattoos Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 5, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132861/Fine_line_artist_newquay.jpg', alt: 'Fine line tattoo artist Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 6, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132861/Fine_line_artist_newquay.jpg', alt: 'Fine line tattoo artist Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 7, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132860/Tattoo_flash_newquay.jpg', alt: 'Tattoo flash Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 8, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132860/No_appointment_tattoo_newquay_cornwall.jpg', alt: 'No appointment tattoo Newquay Cornwall - Atlantic Coast Tattoo' },
  { id: 9, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132860/Traditional_tattoo_newquay.jpg', alt: 'Traditional tattoo Newquay - Atlantic Coast Tattoo Cornwall' },
  { id: 10, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1785132859/Couples_tattoos_newquay.jpg', alt: 'Couples tattoos Newquay - Atlantic Coast Tattoo Cornwall' },
];

const Services = () => {
  const navigate = useNavigate();
  const [slide, setSlide] = useState(0);
  const [paused, setPaused] = useState(false);
  const [swipeStartX, setSwipeStartX] = useState(null);

  const goTo = (i) => setSlide((i + walkInTattoos.length) % walkInTattoos.length);

  const handlePointerDown = (e) => { setSwipeStartX(e.clientX); setPaused(true); };
  const handlePointerUp = (e) => {
    if (swipeStartX !== null) {
      const delta = e.clientX - swipeStartX;
      if (delta > 40) goTo(slide - 1);
      else if (delta < -40) goTo(slide + 1);
    }
    setSwipeStartX(null);
    if (e.pointerType !== 'mouse') setPaused(false);
  };

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setSlide((i) => (i + 1) % walkInTattoos.length);
    }, 2000);
    return () => clearInterval(timer);
  }, [paused]);

  return (
    <section id="services" className="relative py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Studio Section */}
        <div className="mb-32">
          <div className="text-center mb-16">
            <h2 className="font-display text-4xl md:text-6xl font-bold text-white mb-6">
              OUR STUDIO
            </h2>
            <p className="text-xl text-white/80 max-w-4xl mx-auto leading-relaxed mb-12">
              Our studio is one of the oldest name, most known tattoo shops in Cornwall, that has many well known artists working with us as well as famous people getting inked in the studio. Atlantic Coast Tattoo studio has a best reputation around Cornwall including awards of "3 best rated" tattoo studios in Cornwall almost decade in the row.
            </p>

            {/* Studio Image */}
            <div className="relative h-96 max-w-5xl mx-auto overflow-hidden">
              <img
                src="https://res.cloudinary.com/ddclgpokn/image/upload/v1776144091/5F0DCE33-C509-4FB9-8DFE-7D29A2E0EC0E_cgyr6j.jpg"
                alt="Atlantic Coast Tattoo studio storefront Newquay Cornwall - professional tattoo shop at 18 Cliff Road with illuminated signage"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
          </div>
        </div>

        {/* Laser Removal Service */}
        <div className="mb-20">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-white mb-6">
              LASER TATTOO REMOVAL
            </h2>
            <p className="text-white/80 text-lg leading-relaxed mb-6">
              Professional laser tattoo removal service using high-end equipment. Jerry is a laser tattoo removal specialist with over 10 years of experience. Whether you want to remove or fade an existing tattoo to make room for a new one, we can help.
            </p>
            <div className="flex items-center justify-center gap-3 text-white/90 mb-8">
              <Zap className="text-white" size={24} />
              <span className="text-sm tracking-wider">HIGH-END EQUIPMENT | 10+ YEARS EXPERIENCE</span>
            </div>
            <button
              onClick={() => navigate('/laser-removal')}
              className="bg-white text-black px-8 py-3 text-sm tracking-widest hover:bg-gray-200 transition-colors"
            >
              LEARN MORE
            </button>
          </div>
        </div>

        {/* Custom Tattoos */}
        <div className="text-center">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white mb-6">
            CUSTOM TATTOOS
          </h2>

          <p className="text-white/80 text-lg max-w-3xl mx-auto mb-8">
            We specialize in custom work and love transforming your ideas into tattoos that you will cherish for a lifetime. We also offer smaller tattoos and flash designs on a walk-in basis.
          </p>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white/5 p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
              <h3 className="text-white text-xl tracking-wider mb-3">CUSTOM DESIGNS</h3>
              <p className="text-white/70">Unique, personalized tattoos crafted to your vision</p>
            </div>
            <div className="bg-white/5 p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
              <h3 className="text-white text-xl tracking-wider mb-3">WALK-INS WELCOME</h3>
              <p className="text-white/70">Smaller tattoos and flash designs available</p>
            </div>
            <div className="bg-white/5 p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
              <h3 className="text-white text-xl tracking-wider mb-3">AWARD WINNING</h3>
              <p className="text-white/70">Multi-award winning artists with decades of experience</p>
            </div>
          </div>
        </div>

        {/* Walk-in Tattoos Gallery */}
        <div className="mt-32">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-white mb-4">
              WALK-IN TATTOOS
            </h2>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Fine line, flash designs and smaller custom pieces — no appointment needed
            </p>
          </div>
          <div
            data-testid="walkin-slideshow"
            data-paused={paused}
            className="relative w-full max-w-3xl mx-auto pb-[100%] sm:pb-[75%] overflow-hidden bg-white/5 select-none touch-pan-y cursor-grab active:cursor-grabbing"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => { setPaused(false); setSwipeStartX(null); }}
            onPointerDown={handlePointerDown}
            onPointerUp={handlePointerUp}
            onPointerCancel={() => { setSwipeStartX(null); setPaused(false); }}
            onContextMenu={(e) => e.preventDefault()}
          >
            {walkInTattoos.map((image, i) => (
              <img
                key={image.id}
                data-testid={`walkin-slide-${i}`}
                data-active={i === slide}
                src={image.url}
                alt={image.alt}
                loading={i === 0 ? 'eager' : 'lazy'}
                className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out"
                style={{ opacity: i === slide ? 1 : 0, WebkitTouchCallout: 'none' }}
                draggable={false}
              />
            ))}
            {paused && (
              <span
                data-testid="walkin-paused-label"
                className="absolute top-3 right-3 z-10 bg-black/60 text-white/90 text-[10px] tracking-widest px-2 py-1"
              >
                PAUSED
              </span>
            )}
            <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10">
              {walkInTattoos.map((image, i) => (
                <button
                  key={image.id}
                  data-testid={`walkin-dot-${i}`}
                  aria-label={`Show slide ${i + 1}`}
                  onClick={() => setSlide(i)}
                  className={`h-1.5 rounded-full transition-all duration-300 ${
                    i === slide ? 'w-6 bg-white' : 'w-1.5 bg-white/40 hover:bg-white/70'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;